import React from 'react';
import AgentLogin from '../components/auth/AgentLogin';

const AgentLoginPage = () => {
  return <AgentLogin />;
};

export default AgentLoginPage;